var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9531",
    "data-name": "Group 9531",
    transform: "translate(-350.159 -1522.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3323",
    "data-name": "Path 3323",
    d: "M357.662,1537.467a7.5,7.5,0,1,1,7.5-7.485A7.5,7.5,0,0,1,357.662,1537.467Zm6.418-7.456a6.421,6.421,0,1,0-6.408,6.377A6.432,6.432,0,0,0,364.08,1530.011Z",
    fill: "#81c779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3324",
    "data-name": "Path 3324",
    d: "M375.551,1547.849c-.027-1.027-.094-1.957-.052-2.882.014-.3.287-.8.492-.826.55-.074.574.419.566.84-.016.926-.034,1.851-.055,2.948,1.078-.038,2.032-.109,2.983-.08.268.008.715.278.753.488.093.506-.35.575-.757.567-.954-.018-1.908-.038-3-.06.029,1.055.057,2.008.08,2.962.009.4-.022.817-.549.809s-.538-.433-.532-.826c.014-.93.033-1.86.052-2.919-1.029.012-1.973.024-2.917.032-.387,0-.829.018-.839-.513-.011-.574.448-.572.866-.568Z",
    transform: "translate(-18.341 -18.389)",
    fill: "#81c779"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreation);
export default __webpack_public_path__ + "static/media/creation.8458ad76bed22cd8844fc8de522ecc44.svg";
export { ForwardRef as ReactComponent };